import { Col, Row, Tabs, TabsProps } from "antd";
import React from "react";
import TaxRates from "./TaxRates";
import { CTConfigurationPageType } from "../../Services/CTConfigurationService";
import CapitalAllowance from "./CapitalAllowance";
import RnDRates from "./RnDRates";
import AnnualInvestmentAllowance from "./AnnualInvestmentAllowance";
import AssetCategories from "./AssetCategories";
import { PageHeader } from "../../Common/MainLayout";

const CTConfiguration = () => {
  // const [loading, setLoading] = React.useState(false);
  const [pageType, setPageType] = React.useState({
    type: CTConfigurationPageType.TaxRates,
  });

  const onChange = (key: any) => {
    var num = parseInt(key, 10);
    setPageType({ type: num });
  };

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Tax rates",
    },
    {
      key: "2",
      label: "Capital allowance",
    },
    {
      key: "3",
      label: "R & D rates",
    },
    {
      key: "4",
      label: "Annual investment allowance",
    },
    {
      key: "5",
      label: "Asset categories",
    },
    // {
    //   key: "6",
    //   label: "Company Names",
    // },
  ];
  return (
    <>
      <Row justify="start" align="middle" style={{ margin: "1px 15px" }}>
        <PageHeader
          item={[
            {
              label: "CTConfiguration",
              path: "/ctconfiguration",
            },
            {
              label:
                pageType.type === CTConfigurationPageType.TaxRates
                  ? "Tax Rates"
                  : pageType.type === CTConfigurationPageType.CapitalAllowance
                  ? "Captial Allowance"
                  : pageType.type === CTConfigurationPageType.RnDRates
                  ? "R&DRates"
                  : pageType.type ===
                    CTConfigurationPageType.AnnualInvestmentAllowance
                  ? "Annual Investment Allowance"
                  : pageType.type === CTConfigurationPageType.AssetCategories
                  ? "Asset Categories"
                  : pageType.type === CTConfigurationPageType.CompanyNames
                  ? "Company Names"
                  : "",
            },
          ]}
          style={{ color: "#172B4D" }}
        />
      </Row>
      <Row
        className="roundedCornerSmall px-3 py-1"
        style={{ backgroundColor: "white",height:'100%' }}
      >
        <Col span={24}>
          <Row>
            <Col span={23}>
              <Tabs
                defaultActiveKey="1"
                size="small"
                items={items}
                onChange={onChange}
              />
            </Col>
          </Row>
          {pageType.type === CTConfigurationPageType.TaxRates && <TaxRates />}
          {pageType.type === CTConfigurationPageType.CapitalAllowance && (
            <CapitalAllowance />
          )}
          {pageType.type === CTConfigurationPageType.RnDRates && <RnDRates />}
          {pageType.type ===
            CTConfigurationPageType.AnnualInvestmentAllowance && (
            <AnnualInvestmentAllowance />
          )}
          {pageType.type === CTConfigurationPageType.AssetCategories && (
            <AssetCategories />
          )}
        </Col>
      </Row>
    </>
  );
};

export default CTConfiguration;
